function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sound from 'react-sound';
import CircularProgressBar from './circular-progress-bar';

var TonePlayer = /*#__PURE__*/function (_Component) {
  _inherits(TonePlayer, _Component);

  var _super = _createSuper(TonePlayer);

  function TonePlayer(props) {
    var _this;

    _classCallCheck(this, TonePlayer);

    _this = _super.call(this, props);
    _this.state = {
      playStatus: Sound.status.PLAYING,
      position: 0,
      percentage: 0
    };
    _this.play = _this.play.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    _this.handleOnFinishedPlaying = _this.handleOnFinishedPlaying.bind(_assertThisInitialized(_this));
    _this.handleOnPlaying = _this.handleOnPlaying.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TonePlayer, [{
    key: "play",
    value: function play() {
      this.setState({
        position: 0,
        playStatus: Sound.status.PLAYING
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.setState({
        playStatus: Sound.status.STOPPED,
        position: 0,
        percentage: 0
      });
    }
  }, {
    key: "handleOnPlaying",
    value: function handleOnPlaying(_ref) {
      var position = _ref.position,
          duration = _ref.duration;
      var percentage = Math.floor(position) / duration * 100;
      this.setState({
        position: position,
        percentage: percentage
      });
      this.props.onPlaying({
        position: position,
        duration: duration
      });
    }
  }, {
    key: "handleOnFinishedPlaying",
    value: function handleOnFinishedPlaying() {
      this.setState({
        playStatus: Sound.status.STOPPED
      });
      this.props.onFinishedPlaying();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          soundFile = _this$props.soundFile,
          volume = _this$props.volume,
          controlsEnabled = _this$props.controlsEnabled;
      var _this$state = this.state,
          playStatus = _this$state.playStatus,
          position = _this$state.position,
          percentage = _this$state.percentage;
      return /*#__PURE__*/React.createElement("div", {
        className: "tone-player"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circular-progress-bar__wrapper"
      }, /*#__PURE__*/React.createElement(CircularProgressBar, {
        sqSize: 60,
        percentage: percentage,
        strokeWidth: 2
      }), playStatus === Sound.status.PLAYING ? /*#__PURE__*/React.createElement("div", {
        role: "button",
        className: "tone-player__control tone-player__control--stop",
        onClick: function onClick() {
          return controlsEnabled && _this2.stop();
        },
        onKeyPress: function onKeyPress() {
          return controlsEnabled && _this2.stop();
        },
        tabIndex: "0"
      }) : /*#__PURE__*/React.createElement("div", {
        role: "button",
        className: "tone-player__control  tone-player__control--play",
        onClick: function onClick() {
          return controlsEnabled && _this2.play();
        },
        onKeyPress: function onKeyPress() {
          return controlsEnabled && _this2.play();
        },
        tabIndex: "0"
      })), playStatus === Sound.status.PLAYING && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Sound, {
        url: soundFile,
        playStatus: playStatus,
        position: position,
        volume: volume,
        onPlaying: this.handleOnPlaying,
        onFinishedPlaying: this.handleOnFinishedPlaying
      })));
    }
  }]);

  return TonePlayer;
}(Component);

TonePlayer.propTypes = {
  soundFile: PropTypes.string.isRequired,
  volume: PropTypes.number,
  onPlaying: PropTypes.func,
  onFinishedPlaying: PropTypes.func,
  controlsEnabled: PropTypes.bool
};
TonePlayer.defaultProps = {
  volume: 100,
  onPlaying: function onPlaying() {},
  onFinishedPlaying: function onFinishedPlaying() {},
  controlsEnabled: true
};
export default TonePlayer;